module.exports = __webpack_public_path__ + "img/IconView.f3d17ccd.svg";